(function (window, $, StripeSdk, undefined) {
    window.JVZoo = window.JVZoo || {};
    window.JVZoo.Checkout = window.JVZoo.Checkout || {};
    window.JVZoo.Checkout.Stripe = window.JVZoo.Checkout.Stripe || {};

    var _publishableKey = null;
    var _sdkOptions = {};
    var _clientSecret = null;
    var _intentId = null;
    var _intentStatusSuccessId = null;

    var _paymentRequestParameters = null;
    var _paymentRequest = null;
    var _paymentRequestButton = null;
    var card = null;


    var pollingAjaxParams = null;
    var pollingRetryLimit = 3;
    var pollingDelayCoefficient = 1500;


    /**
     * Exposes server side values to JS.
     *
     * @param publishableKey
     * @param clientSecret
     * @param connectedStripeAccountId
     * @param iso2CountryCode
     * @param iso3CurrencyCode
     * @param totalLabel
     * @param totalAmount
     * @param intentId
     * @param intentStatusSuccessId
     */
    window.JVZoo.Checkout.Stripe.setConfiguration = function (
        publishableKey,
        clientSecret,
        connectedStripeAccountId,
        iso2CountryCode,
        iso3CurrencyCode,
        totalLabel,
        totalAmount,
        intentId,
        intentStatusSuccessId
    ) {
        _publishableKey = publishableKey;
        if (connectedStripeAccountId) {
            _sdkOptions = {
                stripeAccount: connectedStripeAccountId,
            };
        }
        _clientSecret = clientSecret;
        _intentId = intentId;
        _intentStatusSuccessId = intentStatusSuccessId;

        _paymentRequestParameters = {
            country: iso2CountryCode,
            currency: iso3CurrencyCode,
            total: {
                label: totalLabel,
                amount: totalAmount,
            },
            requestPayerName: true,
            requestPayerEmail: true,
        };
    };


    /**
     * Simply displays a error message banner directing user to contact support
     * @private
     */
    var _contactSupportMessage = function () {
        window.JVZoo.Checkout.CreditCardError(
            'There was a problem with processing your payment. Please <a href="https://www.jvzoosupport.com" target="_blank" rel="noopener noreferrer">contact support</a>'
        );
    };


    var _setSetupIntentResponse = function (json) {
        window.JVZoo.Checkout.SetPaymentProcessingToken(
            json,
            null
        );
    };

    /**
     * Cancel intent by intent ID
     *
     * @param intent intent ID
     * @private
     */
    var _cancelIntent = function (intent) {
        // This should really be a post...will work for now
        $.get('/checkout/stripe/cancelPaymentIntent/' + intent, function () {
            return true;
        })
            .fail(function () {
                _contactSupportMessage();
                return false;
            });
    };


    /**
     * Show error/support message and cancel intent
     *
     * @param intent intent ID
     * @private
     */
    var _throwPollingError = function (intent) {
        _contactSupportMessage();
        _cancelIntent(intent);
    };


    /**
     * Validates CC form
     *
     * @param $rootElement
     * @returns {boolean}
     * @private
     */
    var _validateCcForm = function ($rootElement) {

        if (!window.JVZoo.Checkout.ValidateCreditCardInfoSection($rootElement)) {
            return false;
        }
        return true;
    };


    /**
     * Payment processing (post validation and intent status == successful)
     *
     * @param $rootElement
     * @param stripe
     * @param cardElement
     * @private
     */
    var _processPayment = function ($rootElement, stripe, cardElement) {
        window.JVZoo.Checkout.ShowCreditCardProcessing();

        var cardPaymentData = {
            payment_method_data: {
                billing_details: {
                    name: window.JVZoo.Checkout.GetCardHolderName(),
                    email: window.JVZoo.Checkout.GetContactEmail(),
                }
            }
        };

        if (!window.JVZoo.Checkout.getIsGoogleApplePayToggled()) {
            cardPaymentData.payment_method_data.billing_details.address = {
                city: window.JVZoo.Checkout.GetBillingAddressCity(),
                country: window.JVZoo.Checkout.GetBillingAddressCountryIso2(),
                line1: window.JVZoo.Checkout.GetBillingAddressLine1(),
                line2: window.JVZoo.Checkout.GetBillingAddressLine2(),
                postal_code: window.JVZoo.Checkout.GetBillingAddressPostalCode(),
                state: window.JVZoo.Checkout.GetBillingAddressState(),
            };
        }

        if (window.JVZoo.Checkout.Show) {

        }

        stripe.handleCardSetup(
            _clientSecret,
            cardElement,
            cardPaymentData
        ).then(function (result) {
            console.debug('HANDLE CARD PAYMENT RESULT: ', result);
            if (result.error || result.setupIntent === undefined) {
                console.error(result.error);
                // Inform the customer that there was an error.
                window.JVZoo.Checkout.SetCreditCardNumberError(result.error.message);
                window.JVZoo.Checkout.HideCreditCardProcessing();
                return;
            }
            // The payment has succeeded. Display a success message.
            console.debug("SUCCESS!!");
            _setSetupIntentResponse(JSON.stringify(result.setupIntent));
            window.JVZoo.Checkout.SubmitOrderFormAsCreditCardPayment();
        })
            .catch(function (error) {
                console.error(error);
                window.JVZoo.Checkout.SetCreditCardNumberError("An error occurred while trying to complete payment. Please try again.");
                window.JVZoo.Checkout.HideCreditCardProcessing();
            })
            .finally(function () {
                //window.JVZoo.Checkout.HideCreditCardProcessing();
            });
        // stripe.createToken(card)
        //     .then(function(result) {
        //             if (result.error || !result.token) {
        //                 console.error(error);
        //                 console.error('Card does not appear valid: ', result.error.message);
        //                 // Inform the customer that there was an error.
        //                 window.JVZoo.Checkout.SetCreditCardNumberError(result.error.message);
        //                 window.JVZoo.Checkout.HideCreditCardProcessing();
        //                 return;
        //             }
        //             console.info('Card appears valid.');
        //             window.JVZoo.Checkout.SetPaymentProcessingToken(
        //                 result.token.id,
        //                 _payemntIntentExpiresOn
        //             );
        //             window.JVZoo.Checkout.SubmitOrderFormAsCreditCardPayment();
        //         }
        //     )
        //     .catch(function (error) {
        //         console.error(error);
        //     })
        //     .finally(function () {
        //         window.JVZoo.Checkout.HideCreditCardProcessing();
        //     });
    };


    /**
     * Dispatches polling to receive intent status
     *
     * @param intentId
     * @param $rootElement
     * @param stripe
     * @param card
     * @returns {jQuery|*}
     * @private
     */
    var _pollForPaymentIntentStatus = function (intentId, $rootElement, stripe, card) {

        return $.ajax({
            url: '/checkout/stripe/pollpaymentintentstatus/' + intentId,
            type: 'get',
            tryCount: 0,
            crossDomain: false,
            retryLimit: pollingRetryLimit,
            dataType: 'json',
            beforeSend: function (jqXHR, settings) {
                console.debug("Requesting status of Payment Intent: ", intentId, "\n\tjqXHR: ", jqXHR);
            },
            dataFilter: function (data, type) {
                console.debug("Raw response status for Payment Intent: ", intentId, "\n\tData: ", data, "\n\ttype:", type);
                return data;
            },
            success: function (intentStatusResponse) {
                console.debug("Received Payment Intent response");
                if (Number(intentStatusResponse.intent_status_id) === Number(_intentStatusSuccessId)) {

                } else {
                    this.tryCount++;

                    if (this.tryCount <= this.retryLimit) {

                        pollingAjaxParams = this;

                        setTimeout(function () {
                            $.ajax(pollingAjaxParams);
                        }, pollingDelayCoefficient * this.tryCount, pollingAjaxParams);
                    } else {
                        _throwPollingError(intentId);
                    }
                }
            },
            error: function (jqXHR, status, error) {
                console.debug("Status Request completed for Payment Intent: " + intentId, "\n\tjqXHR: ", jqXHR, "\n\tstatus: ", status, "\n\tError: ", error);
                this.tryCount++;

                if (this.tryCount <= this.retryLimit) {

                    pollingAjaxParams = this;

                    setTimeout(function () {
                        $.ajax(pollingAjaxParams);
                    }, pollingDelayCoefficient * this.tryCount, pollingAjaxParams);
                } else {
                    _throwPollingError(intentId);
                }
            },
            complete: function (obj) {
                console.debug("Status Request completed for Payment Intent: " + intentId, "\n\tobject: ", obj);
            }
        });
    };

    var _buildAttemptPurchaseMethod = function ($rootElement, stripe, card) {
        return function (e) {
            e.preventDefault();

            // Validate Form
            if (!_validateCcForm($rootElement)) {
                return;
            }

            //Process payment
            _processPayment($rootElement, stripe, card);

            // Poll for intent
            // _pollForPaymentIntentStatus(_intentId, $rootElement, stripe, card);
        };
    };

    window.JVZoo.Checkout.Stripe.applyBindings = function (root) {

        var $rootElement = root instanceof $ ? root : $(root);

        /*
         * Initialize Stripe
         */
        var stripe = StripeSdk(_publishableKey, _sdkOptions);

        /*
         * Options used for multiple stripe elements.
         */
        var options = {
            mode: 'setup',
            currency: 'usd',
            // amount: window.JVZoo.Checkout.getCurrentPaymentPrice(),
            appearance: {
                theme: 'stripe',
            }
        };

        /*
         * Init the stripe elements.
         */
        var elements = stripe.elements(options);

        /*
         * Build configs for behavior.
         */
        var customizationOptions = {
            layout: 'tabs',
            terms: {
                card: 'never',
                applePay: 'auto',
                googlePay: 'never'
            },
            business: {
                name: "BBC Systems, Inc."
            },
            fields: {
                billingDetails: {
                    address: 'if_required',
                }
            },
        }

        /*
         * Create a 'payment' object
         */
        var payment = elements.create('payment', customizationOptions);
        payment.mount('#stripe-dynamic-fields');
        /*
         * Monitor for validation
         */
        payment.addEventListener('change', function (event) {
            if (!event.error) {
                window.JVZoo.Checkout.SetCreditCardNumberError(null);
                return;
            }

            if (event.value.postalCode) {
                window.JVZoo.Checkout.SetBillingAddressZipCode(event.value.postalCode);
            }

            window.JVZoo.Checkout.SetCreditCardNumberError(event.error.message);

        });

        payment.on('change', function(event) {
            if (event.value && event.elementType == "payment") {
                const cardBody = document.querySelector('.card-body');
                if (event.value.type === 'apple_pay' || event.value.type === 'google_pay') {
                    window.JVZoo.Checkout.setIsGoogleApplePayToggled(true);
                    cardBody.style.display = 'none';
                } else{
                    window.JVZoo.Checkout.setIsGoogleApplePayToggled(false);
                    cardBody.style.display = 'block';
                }
            }
        });

        /*
         * Intercept form submit
         */
        $rootElement.on(
            'click',
            window.JVZoo.Checkout.PayByStripeButtonJquerySelector,
            _buildAttemptPurchaseMethod($rootElement, stripe, payment)
        );
    };

    $(document).ready(function () {

        window.JVZoo.Checkout.Stripe.applyBindings($(document));

    });

})(window, jQuery, Stripe);